import { Box, Stack } from "@mui/material";

interface ProgressBarsProps {
  readonly currentStep: number;
  readonly totalSteps: number;
}

export function ProgressBars(props: ProgressBarsProps) {
  const { currentStep, totalSteps } = props;

  return (
    <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          sx={(theme) => ({
            position: "relative",
            flex: 1,
            height: "4px",
            borderRadius: "2px",
            overflow: "hidden",
            backgroundColor: theme.palette.grey[300],
          })}
        >
          <Box
            sx={(theme) => ({
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: index <= currentStep ? "100%" : "0%",
              backgroundColor: theme.palette.background.invert,
              borderRadius: "2px",
              transition: theme.transitions.create("width", {
                duration: theme.transitions.duration.standard,
                easing: theme.transitions.easing.easeInOut,
              }),
            })}
          />
        </Box>
      ))}
    </Stack>
  );
}
